import { render, staticRenderFns } from "./client-work.vue?vue&type=template&id=14396d06&scoped=true&"
import script from "./client-work.vue?vue&type=script&lang=ts&"
export * from "./client-work.vue?vue&type=script&lang=ts&"
import style0 from "./client-work.vue?vue&type=style&index=0&id=14396d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14396d06",
  null
  
)

component.options.__file = "client-work.vue"
export default component.exports